import useServiceFactory from "../serviceFactory";

const apiUrlSource = `/source`;

const useApiAsistenteIA = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });
    return {
       getCategorias: async () => service.get(`${apiUrlSource}/categoriaIA/`, { showLoading: true }),
    }
};

export default useApiAsistenteIA;
